import React from "react";

const Anouncement = () => {
  return (
    <div className="fixed z-[10] top-0 left-0 right-0 mt-[75px] bg-gray-800  -mx-4 h-10 text-white flex items-center justify-center text-xs">
      <p className="text-[10px] sm:text-sm flex flex-col sm:flex-row">
        Get Google Sheet Formulas within seconds using AI. ✨
        <a
          href="https://sheetgod.boloforms.com"
          target="_blank"
          className="text-blue-400 underline sm:ml-2"
          rel="noreferrer"
        >
          Try SheetGod!
        </a>{" "}
      </p>
    </div>
  );
};

export default Anouncement;
